export function sortProfilesByName(profiles) {
  return [...profiles].sort((left, right) =>
    left.name.localeCompare(right.name, undefined, { sensitivity: "base" })
    || left.id.localeCompare(right.id));
}
